import { Tag } from 'antd';
import { ExamQuestionTypeEnum, ExamStatusEnum } from '../../api';

export const questionTypeMapping: Record<ExamQuestionTypeEnum, string> = {
  [ExamQuestionTypeEnum.SINGLE]: '单选题',
  [ExamQuestionTypeEnum.MULTIPLE]: '多选题',
  [ExamQuestionTypeEnum.JUDGE]: '判断题',
};

export const questionTypeColor: Record<ExamQuestionTypeEnum, string> = {
  [ExamQuestionTypeEnum.SINGLE]: 'blue',
  [ExamQuestionTypeEnum.MULTIPLE]: 'purple',
  [ExamQuestionTypeEnum.JUDGE]: 'cyan',
};

export const examStatusMapping: Record<ExamStatusEnum, string> = {
  [ExamStatusEnum.PUBLISHED]: '已发布',
  [ExamStatusEnum.CLOSED]: '已关闭',
};

export const QuestionTypeTag = ({ type }: { type?: ExamQuestionTypeEnum }) => {
  if (!type) {
    return <>-</>;
  }
  return <Tag color={questionTypeColor[type]}>{questionTypeMapping[type]}</Tag>;
};

// 选项下标 -> 字母
export const optionLetter = (index: number) => String.fromCharCode(65 + index);

// 秒 -> 「x分y秒」
export const formatDuration = (seconds?: number) => {
  if (seconds === undefined || seconds === null) {
    return '-';
  }
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  if (minutes === 0) {
    return `${rest}秒`;
  }
  return `${minutes}分${rest}秒`;
};
